import { useEffect, useState } from 'react';

/**
 * "עכשיו" כערך יציב בזמן render, שמתעדכן בקצב קבוע.
 *
 * קריאה ל Date.now() ישירות בזמן render אינה טהורה: התוצאה משתנה בין
 * רינדורים גם בלי שינוי בנתונים. כאן הזמן הוא state, כך שתצוגות שתלויות
 * בו (ספירה לאחור, "פג תוקף") מתעדכנות במפורש ולא במקרה.
 */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);

  return now;
}
